import { useState } from 'react'
import { ApiGetCall } from '../../../JS/Connector';
import { formatDateToMMDDYYYY, HideLoder, LogInSchoolID, ShowLoder } from '../../../JS/Common';
import AlertsComp from '../../../Components/AlertsComp';

export default function Exporttickets({ FilterData, setAlerts }) {
    const [loading, setLoading] = useState(false);

    async function ExportRepairTicket() {
        setLoading(true);

        setTimeout(() => {
            setLoading(false);
            setAlerts(<AlertsComp show={true} variant="success" msg={`You will receive an email notification once matching data is found and processed.`} />);
        }, 2000);

        setTimeout(() => {
            setAlerts(<AlertsComp show={false} />);
        }, 5000);

        setTimeout(() => {
            ApiGetCall(`/tickets/export?schoolId=${LogInSchoolID}&flag=4&startDate=${formatDateToMMDDYYYY(FilterData.StartDate)}&endDate=${formatDateToMMDDYYYY(FilterData.EndDate)}`)
        }, 0);
    }

    return (
        <>
            {loading ? <ShowLoder /> : <HideLoder />}
            <div className='row d-flex align-items-center p-1'>
                <span className='GridTitle'>Export Tickets</span>
            </div>
            <div className='col-12'>
                <img src='/images/HorizontalLine.svg' className='img-fluid w-100' />
            </div>
            <div className="p-2">
                <p className="text-justify" style={{ fontSize: "13px" }}>
                    To efficiently export all of your tickets, utilize the option below, which allows you to download them in a single CSV file. This streamlined process ensures you have easy access to all your ticket data.
                </p>
                <div className="row pt-3 pb-5 px-3">
                    <div className="col-12 px-0 py-2">
                        <label className='BorderBtnForimportExport' onClick={ExportRepairTicket}>Export Tickets
                            <img src='/images/ExportInventory.svg' className='img-fluid ps-2' />
                        </label>
                    </div>
                </div>
            </div>
        </>
    )
}
